<template>
    <div class="mypopinfo">
        <template v-if="$common.courseinfotype.Guide(info.courseinfotypekv)">
            <div class="title"><span class="arrow"></span><span class="word"><i class="iconfont icon-zaixianzhidao"></i><span v-html="$common.langinfo(info.title,info.title_en)"></span></span></div>
            <div class="con staticrail">

                <div v-if="!$common.basic.chempty(info.content)" :class="['info',[(info.content && info.content_en)?'infocolumn':'']]">
                    <myScroll class="scroll">
                        <div class="content editor" v-html="info.content"></div>
                    </myScroll>
                </div>
                <div :class="['info',[(info.content && info.content_en)?'infocolumn':'']]">
                    <myScroll class="scroll" :ops="(info.content&&(!$store.getters.issmall))?{ rail: { opacity: 1, keepShow: true } }:{}">
                        <div class="content editor" v-html="info.content_en"></div>
                    </myScroll>
                </div>

            </div>
        </template>
        <template v-else>
            <div class="title"><span class="arrow"></span><span class="word"><i class="iconfont icon-renwu"></i><span v-html="$common.langinfo(info.title,info.title_en)"></span></span></div>
            <div class="con">
                <div class="info">
                    <myScroll class="scroll">
                        <div class="content">
                            <div class="editor" v-html="$common.langinfo(info.content,info.content_en)"></div>
                            <template v-if="$common.courseinfotype.Writing(info.courseinfotypekv)">
                                <div class="spline"></div>

                                <div v-if="infomemwriting.stat>1" class="answer">
                                    {{$common.dicword('submittime',true)}}{{$common.basic.dateformat(infomemwriting.datesubmit,'yyyy-MM-dd hh:mm')}}
                                    <template v-if="!$store.getters.isstu">
                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$common.dicword('learner',true)}}{{infomemwriting.username}}
                                    </template>

                                    <br /><br />
                                    <span v-html="$common.basic.strarea2editor(infomemwriting.conanswer)"></span>
                                </div>
                                <template v-if="islearning &&  (infomemwriting.stat<=1)">

                                    <div class="input"><textarea v-model="infomemwriting.conanswer"></textarea></div>
                                    <div class="btn"><a href="#" @click="writingsave(1)">{{$common.dicword('save')}}</a><a href="#" @click="writingsave(2)">{{$common.dicword('submit')}}</a></div>
                                </template>
                                <template v-if="isreview">
                                    <div class="spline"></div>
                                    <div class="input"><textarea v-model="infomemwriting.confeedback"></textarea></div>
                                    <div class="btn"><a href="#" @click="writingsave(4)">{{$common.dicword('submit')}}</a></div>
                                </template>
                                <template v-if="infomemwriting.stat==4">
                                    <div class="spline"></div>
                                    <div class="feedback">
                                        {{$common.dicword('commenttime',true)}}{{$common.basic.dateformat(infomemwriting.datefeedback,'yyyy-MM-dd hh:mm')}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$common.dicword('commentteacher',true)}}{{infomemwriting.teaname}}
                                        <br /><br />
                                        <span v-html="$common.basic.strarea2editor(infomemwriting.confeedback)"></span>
                                    </div>
                                </template>
                                <template v-if="info.conreference">
                                    <div class="answer">
                                        Reference:
                                        <br /><br />
                                        <span v-html="info.conreference"></span>
                                    </div>
                                </template>
                            </template>

                        </div>

                    </myScroll>
                </div>
            </div>
        </template>
    </div>

</template>

<script>
    export default {
        name: 'Ccourseinfo',
        data() {
            return {
                info: {},
                infomemwriting: {}
            };
        },
        props: {
            id: {
                type: Number,
                default: 0
            },
            islearning: {
                type: Boolean,
                default: false
            },
            isreview: {
                type: Boolean,
                default: false
            },
            courseinfo: {
                type: Object,
                default: () => { }
            }
        },
        methods: {
            initdata: function () {
                this.info = this.$common.basic.jsonclone(this.courseinfo);
                if (this.$common.courseinfotype.Writing(this.info.courseinfotypekv)) {
                    let jsondata = {
                        'postdata': { 'act': 'tc_learn_writing', 'id': this.id, 'data': { 'infoid': this.info.id, 'isreview': this.isreview ? 1 : 0 } }
                    };
                    this.$common.post(jsondata, res => {
                        if (res.ismine == 1) {
                            if (res.infodata.id) {
                                if (res.infodata.stat == 1) {
                                    res.infodata.conanswer = this.$common.basic.streditor2area(res.infodata.conanswer);
                                }
                                if ((res.infodata.stat == 2) || (res.infodata.stat == 3)) {
                                    res.infodata.confeedback = this.$common.basic.streditor2area(res.infodata.confeedback);
                                }
                                this.info.content = res.infodata.conquestion;
                                this.info.content_en = '';
                            }
                            this.infomemwriting = res.infodata;
                        }
                        else {
                            this.$emit('update:visible', false);
                            this.$common.alert(res.msg);//应该不会出现
                        }

                    });
                }
            },
            writingsave: function (v) {
                let save = () => {
                    let jsondata = {
                        'postdata': { 'act': 'tc_learn_writingsave', 'id': this.infomemwriting.id || 0, 'data': { 'conwriting': v == 4 ? this.infomemwriting.confeedback : this.infomemwriting.conanswer, 'stat': v, 'infoid': this.info.id } }
                    };
                    this.$common.post(jsondata, () => {
                        this.infomemwriting.stat = v;
                        if (v == 1) {
                            this.$common.success(this.$common.dicword('saved'));
                        }
                        else {
                            if (v == 2) {
                                this.infomemwriting.datesubmit = new Date();
                            }
                            else if (v == 4) {
                                this.infomemwriting.datefeedback = new Date();
                            }
                            this.$emit('ffsubmit', v);
                        }
                    });
                };

                if (v == 2) {

                    this.$common.confirm(this.$common.dicword('confirmactivitysubmit'), () => {
                        save();
                    })
                }
                else {
                    save();
                }
            }
        },
        mounted() {
            this.initdata();
        }
    }
</script>
